import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class CodeEditorMachine {
  constructor() {
    _defineProperty(this, "_value", "");
    _defineProperty(this, "_cursorPos", -1);
  }
  // "friend" fields, also override so use get/set accessors

  get aceEditor() {
    return this._aceEditor;
  }
  set aceEditor(editor) {
    this._aceEditor = editor;
  }
  get cursorPos() {
    return this._cursorPos;
  }
  set cursorPos(value) {
    this._cursorPos = value;
  }
  get value() {
    if (this.aceEditor) {
      this._value = this.aceEditor.getValue();
    }
    return this._value;
  }
  set value(value) {
    this._value = value;
    if (this.aceEditor) {
      this.aceEditor.setValue(this._value, this._cursorPos);
    }
  }

  /**
   * Inserts text on the aceEditor value replaces the selection
   * @param {string} text
   */
  insert(text) {
    this.aceEditor.insert(text);
  }

  /**
   * Returns focus to editor
   */
  focusOnEditor() {
    this.aceEditor.focus();
  }
}
//# sourceMappingURL=CodeEditorMachine.js.map
